<template>
  <div>
    <v-modal ref="modalLembrarSenha" id="modalLembrarSenha" titulo="Redefinir a senha">
      <div slot="body">
        <div class="row pr-5 pl-3">
          <div>
            <v-modal ref="modalFastLogin" id="modalFastLogin" titulo="Confirmação de Acesso">
              <div slot="body">
                <p><small>Foi enviado para o seguinte {{ retorno.labelTipo }} um código para confirmação de acesso. A
                  mensagem pode levar alguns segundos para chegar, por favor, aguarde.</small></p>
                <p><small>{{ retorno.mascarado }}</small></p>
                <div class="clearfix mb-4"></div>
                <div v-if="fast.error" class="alert fade show alert-danger col-10">
                  <small v-html="fast.error"></small>
                </div>
                <div class="row">
                  <v-input-text v-model="codigo" label="<b>Digite o código recebido</b>" fieldsetClasse="col-10 mb-4"
                                mask="######"></v-input-text>
                </div>
              </div>
              <div slot="buttons">
                <v-button label="Confirmar" @click="autenticarFast"></v-button>
              </div>
            </v-modal>

            <p v-if="labelView" class="valor text-uppercase">Acesso Rápido</p>
            <form action="" class="row">
              <v-input-text label="Digite seu CPF" v-model="fast.cpf" mask="###.###.###-##"></v-input-text>
              <div class="w-100 mb-4"></div>
              <!--<v-input-select label="Enviar código por" v-model="fast.tipo" :options="tiposFast" :searchable="false"></v-input-select>-->

              <div class="col">
                <label class="label"><b>Enviar por...</b></label>
              </div>
              <div class="w-100"></div>
              <v-button label="SMS" @click="enviarCPF('sms')" fieldsetClasse="col-auto"></v-button>
              <v-button label="E-mail" @click="enviarCPF('email')"></v-button>
            </form>

          </div>
        </div>
      </div>
      <div slot="buttons">
      </div>
    </v-modal>

    <v-modal ref="modalErro2" id="modalErro2" titulo="Ocorreu um Erro" class="alert-danger" ico="ion-alert-circled"
             :showPicture="false" size="30">
      <div slot="body">
        <p v-html="textError"></p>
      </div>
      <div slot="buttons" class="d-block w-100">
        <div class="text-center">
          <button class="button btn rounded-0 button-dark btn-dark" @click="$refs.modalErro2.close()">Fechar</button>
          <button class="button btn rounded-0 button-dark btn-dark" @click="$refs.modalLembrarSenha.show()">Esqueci
            minha senha
          </button>
        </div>
      </div>
    </v-modal>

    <v-modal ref="modalAcessoViaCpf" id="modalAcessoViaCpf" titulo="Acesso a agenda de hoje">
      <div slot="body">
        <div class="clearfix mb-4"></div>
        <div class="row" style="margin-bottom: 25px">
          <v-input-text v-model="autenticacao_rapida.cpf"
                        label="<b>Vamos tentar identificar você. Digite o seu CPF.</b>"
                        fieldsetClasse="col-12 mb-4"
                        mask="###.###.###-##"
                        classe="boxing"
                        @enter="autenticacaoRapidaSoCpf"></v-input-text>
          <v-button label="Confirmar" @click="autenticacaoRapidaSoCpf"></v-button>
        </div>
      </div>
    </v-modal>

    <v-modal ref="modalAcessoViaCpfCompleto" id="modalAcessoViaCpfCompleto" titulo="Acesso a agenda de hoje">
      <div slot="body">
        <div class="clearfix mb-4"></div>
        <div class="row" style="margin-bottom: 25px;">
          <fieldset class="col-12 mb-4">
            <label class="label"><b>Preencha o começo do seu e-mail</b></label>
            <div class="input-group">
              <input type="text" v-model="autenticacao_rapida.confirmacao_do_email"
                     class="form-control rounded-0 boxing" maxlength="5" minlength="5" required
                     @keyup.enter="autenticacaoRapidaCompleto">
              <div class="input-group-append">
                <div class="input-group-text" style="font-size: .65em;"
                     v-text="autenticacao_rapida.email_mascarado"></div>
              </div>
            </div>
          </fieldset>
          <v-button label="Confirmar" @click="autenticacaoRapidaCompleto"></v-button>
        </div>
      </div>
    </v-modal>

    <v-modal ref="modalCpfNaoEncontrado" id="modalCpfNaoEncontrado" titulo="Pagamento rápido" :showPicture="false"
             class="alert-danger" ico="ion-alert-circled" size="30">
      <div slot="body">
        <p v-html="messageCpfNaoEncontrado"></p>
      </div>
      <div slot="buttons" class="row">
        <div class="col">
          <div class="row" style="height: auto;">
            <v-button fieldsetClasse="col-xs-12 col-md-6" label="Tente novamente"
                      @click="$refs.modalAcessoViaCpf.show()" style="height: 45px;"></v-button>
            <v-button fieldsetClasse="col-xs-12 col-md-6" label="Cancelar" style="height: 45px;"
                      @click="$refs.modalCpfNaoEncontrado.close()"></v-button>
          </div>
        </div>
      </div>
    </v-modal>

    <v-modal :showPicture="false" ref="modalSucessoBuscaUsuario" id="modalSucessoBuscaUsuario" class="alert-success"
             size="30">
      <div slot="body">
        <p v-html="mensagem_sucesso"></p>
      </div>
    </v-modal>

    <p class="valor text-uppercase">{{ labelForm }}</p>
    <form action="" class="row" @keyup.enter="autenticar">
      <v-input-text label="CPF" tipo="email" v-model="login.username" required></v-input-text>
      <div class="w-100 mb-4"></div>
      <v-input-text label="Senha" tipo="password" v-model="login.password" required useIconEyes></v-input-text>
      <div class="w-100 mb-4"></div>
      <v-button label="Acessar" :click="autenticar"></v-button>
      <v-button v-if="btnViewEsqueciSenha" label="Esqueceu sua senha?" :click="abrirLembrarSenha" classe=""
                css="background: transparent; color: #6d1614; border: none;"></v-button>
      <v-button v-if="btnViewAgenda" label="Acessar agenda de hoje" fieldsetClasse="col-md-12" :click="verAgenda"
                classe=""
                css="width: 100%; margin-top: 15px; padding: 3px 25px 2px;"></v-button>
    </form>
  </div>
</template>

<script>

export default {
  props: {
    serial: {
      type: String,
      required: true,
    },
    labelView: {
      type: Boolean,
      default: true,
    },
    btnViewAgenda: {
      type: Boolean,
      default: true,
    },
    btnViewEsqueciSenha: {
      type: Boolean,
      default: true,
    },
    clearCredentials: {
      type: Boolean,
      default: true,
    },
    labelForm: {
      type: String,
      default: 'FAZER LOGIN'
    },
    /*esqueciMinhaSenha: {
        type: Number,
        default: 0,
    },*/
  },
  /*components: {
      FastLogin
  },*/
  data() {
    return {
      textError: null,
      login: {
        username: null,
        password: null,
        serial: null,
        grant_type: "password",
        checa_papel: 1,
        captcha: null
      },
      lembrar_senha: {
        nome_solicitante: null,
        login_usuario: null,
      },
      error_lembrar: {
        message: null,
        class: null,
      },
      codigo: null,
      autenticacao_rapida: {
        cpf: null,
        confirmacao_do_email: null,
        email_mascarado: null,
      },
      loginFast: {
        id_usuario: null,
        codigo: null,
        serial: null,
        grant_type: "codigo_acesso",
        checa_papel: 1,
        esqueciMinhaSenha: this.esqueciMinhaSenha,
      },
      fast: {
        cpf: null,
        tipo: null,
        error: null,
      },
      tiposFast: [
        {
          value: 'sms',
          label: 'SMS',
        },
        {
          value: 'email',
          label: 'E-mail',
        },
      ],
      retorno: {
        labelTipo: null,
        mascarado: null,
      },
      esqueciMinhaSenha: 0,
      messageCpfNaoEncontrado: null,
      mensagem_sucesso: null,
    }
  },
  computed: {
    usuario: function () {
      return this.$route.query.usuario
    },
    senha: function () {
      return this.$route.query.senha
    },
  },
  methods: {
    verAgenda() {
      this.$refs.modalAcessoViaCpf.show()
    },
    async autenticacaoRapidaSoCpf() {
      this.messageCpfNaoEncontrado = null
      if (!this.$root.validateCPF(this.autenticacao_rapida.cpf)) {
        this.messageCpfNaoEncontrado = 'CPF inválido!'
        this.$refs.modalCpfNaoEncontrado.show()
        return
      }
      this.buscaUsuarioPorCpf((response) => {
        let dados = response.data.data
        this.autenticacao_rapida.email_mascarado = _.replace(dados.email_mascarado, '*****', '')
        this.$refs.modalAcessoViaCpf.close()
        this.$refs.modalAcessoViaCpfCompleto.show()
      })
    },

    async autenticacaoRapidaCompleto() {

      this.buscaUsuarioPorCpf((response) => {
        let dados = response.data.data
        let nome = _.split(!_.isEmpty(dados.nome_social) ? dados.nome_social : dados.nome_completo, ' ')
        let primeiroNome = nome[0]

        let data = {
          access_token: dados.token_temp,
          refresh_token: null,
          expires: dados.data_hora_expiracao,
        }

        localStorage.setItem('token', data.access_token)
        localStorage.setItem('refresh_token', data.refresh_token)
        localStorage.setItem('expires', data.expires)
        localStorage.setItem('fastLoginAgenda', true)
        this.$store.dispatch('changeAuth', data)
        this.$root.getUsuario(() => {
          this.$root.setAlert(null, 'success')
          setTimeout(() => {
            this.autenticacao_rapida.cpf = null
            this.autenticacao_rapida.confirmacao_do_email = null
            this.autenticacao_rapida.email_mascarado = null

            this.$refs.modalAcessoViaCpfCompleto.close()
            this.mensagem_sucesso = "<b>" + primeiroNome + ', bem-vindo ao PCdoB Digital!</b><br>Já te identificamos e você será redirecionado para a agenda.';
            this.$refs.modalSucessoBuscaUsuario.show()

            setTimeout(() => {
              this.$refs.modalSucessoBuscaUsuario.close()
              // window.open(`http://localhost:8080/agenda?token=${data.access_token}&refresh_token=${data.refresh_token}`)
              location.href = process.env.ENDPOINT_URL + 'agenda';
              return;
            }, 4000)

          }, 100)
        })
      })
    },

    buscaUsuarioPorCpf(funcao) {
      this.messageCpfNaoEncontrado = null
      this.$resources.UsuarioPorCpf.post('', this.autenticacao_rapida).then((response) => {
        if (_.isFunction(funcao)) {
          funcao(response)
        }
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.messageCpfNaoEncontrado = error.response.data.message
          this.autenticacao_rapida.confirmacao_do_email = null
          this.$refs.modalCpfNaoEncontrado.show()
        } else {
          this.$root.setAlert('Ocorreu um erro na solicitação', 'danger')
        }
      })

    },

    autenticar() {
      this.$root.recaptcha(token => {
        this.textError = null
        if (this.$refs.modalErro2 != undefined) {
          this.$refs.modalErro2.close()
        }
        if (this.clearCredentials) {
          localStorage.clear()
        }
        this.login.captcha = token
        this.login.serial = this.serial
        this.$resources.OAuth.post('/', this.login).then((response) => {
          this.$emit('login', response.data.data)
        }).catch((error) => {
          console.dir(error)
          if (error.response && error.response.data) {
            if (error.response.data.message) {
              this.textError = error.response.data.message
              this.$refs.modalErro2.show()
//                            this.$root.setAlert(error.response.data.message, 'danger')
            }
          } else {
            this.textError = 'Ocorreu um erro na solicitação'
            this.$refs.modalErro2.show()
//                        this.$root.setAlert('Ocorreu um erro na solicitação','danger')
          }
        })
      })
    },
    lembrarSenha() {
      this.error_lembrar.message = null
      this.error_lembrar.class = null
      this.$resources.LembrarSenha.put('', this.lembrar_senha).then((response) => {
        if (response.data && response.data.data) {
          this.error_lembrar.message = response.data.data
          this.error_lembrar.class = 'alert-success'
        }
      }).catch((error) => {
        this.error_lembrar.class = 'alert-danger'
        console.dir(error)
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            this.error_lembrar.message = error.response.data.message
          }
          if (error.response.data.errors) {
            this.error_lembrar.message = 'Login e solicitante são obrigatórios'
          }
        } else {
          this.error_lembrar.message = 'Ocorreu um erro na solicitação'
        }
      })
    },
    abrirLembrarSenha() {
      this.$refs.modalLembrarSenha.show()
    },
    enviarCPF(tipo) {
      this.loginFast.esqueciMinhaSenha = 1
      this.fast.esqueci_senha = 1
      this.fast.error = null
      this.fast.tipo = tipo
      this.$resources.CodigoAcesso.post('', this.fast).then((response) => {
        let dados = response.data.data

        let mascarado = ''
        let label = ''
        if (dados.tipo == "sms") {
          label = "telefone celular"
          let hifenPosition = dados.telefone.search('-')
          let endPrefixe = dados.telefone.slice(0, 1) == "(" ? 4 : 2
          mascarado += dados.telefone.slice(0, endPrefixe) + _.repeat('*', 4)
          mascarado += hifenPosition > -1 ? dados.telefone.slice(hifenPosition) : '-' + dados.telefone.slice(-4)
        } else if (dados.tipo == "email") {
          label = "endereço de e-mail"
          let arrobaPosition = dados.email.search('@')
          mascarado = dados.email.slice(0, 2) + _.repeat('*', 4) + dados.email.slice(arrobaPosition)
        }

        this.loginFast.id_usuario = dados.fk_id_usuario
        this.retorno.labelTipo = label
        this.retorno.mascarado = mascarado
        this.$refs.modalFastLogin.show()
        localStorage.setItem('loginFast', JSON.stringify(this.loginFast))
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.$root.setAlert(error.response.data.message, 'danger')
        } else {
          this.$root.setAlert('Ocorreu um erro na solicitação', 'danger')
        }
      })
    },
    autenticarFast() {
      this.loginFast = JSON.parse(localStorage.getItem('loginFast'))
      localStorage.clear()
      this.fast.error = null
      this.loginFast.serial = this.serial
      this.loginFast.codigo = this.codigo
      localStorage.setItem('loginFast', JSON.stringify(this.loginFast))
//                console.dir(this.loginFast)
      this.$resources.OAuth.post('/', this.loginFast).then((response) => {
        localStorage.clear()
        this.$refs.modalFastLogin.close()
        this.$emit('login', response.data.data)
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.fast.error = error.response.data.message
        } else {
          this.fast.error = 'Ocorreu um erro na solicitação'
        }
      })
    },
  },
  created() {
    let params = this.$root.getQueryParams()
    if (params.hasOwnProperty('showRedirect') && params.showRedirect == "1") {
      setTimeout(() => {
        this.$refs.modalLembrarSenha.show()
      }, 500)
    }

    if (this.usuario && this.senha) {
      this.login.username = this.usuario;
      this.login.password = this.senha;
      this.autenticar();
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Autenticacao/LoginForm.vue